"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const AddLetMeKnowMutation = (0, graphql_tag_1.default) `
  mutation addLetMeKnowMutation(
    $sku: ID!
    $name: String!
    $email: String!
    $newsletter: Boolean
    $origin: String
  ) {
    addLetMeKnow(
      letMeKnowRequest: {
        sku: $sku
        name: $name
        email: $email
        newsletter: $newsletter
        origin: $origin
      }
    ) {
      status
    }
  }
`;
exports.default = AddLetMeKnowMutation;
